import React, { createContext, useState, useEffect } from "react";
import { db } from "../index";
import { AuthContext } from "./auth-context";
import { useContext } from "react";
import {
    doc,
    query,
    collection,
    where,
    addDoc,
    deleteDoc,
} from "firebase/firestore";
import { onSnapshot } from "firebase/firestore";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FavoritesContext = createContext({
    favorites: [],
    totalFavorites: 0,
    itemIsFavorite: () => false,
    addFavorite: () => {},
    removeFavorite: () => {},
});

export const FavoritesContextProvider = (props) => {
    const [favorites, setFavorites] = useState([]);
    const getUser = useContext(AuthContext);

    useEffect(() => {
        if (!getUser.user || !getUser.checked) {
            throw new Error("Unauthenticated user!!");
        }

        // create firebase subscription query
        const user_id = getUser.user.uid;
        const sub_query = query(
            collection(db, "user-favorites"),
            where("user_id", "==", user_id)
        );

        //subscribe for updates
        const unsubscribe = onSnapshot(sub_query, (snapshot) => {
            let next_state = [];
            snapshot.forEach((doc) =>
                next_state.push({
                    id: doc.id,
                    ...doc.data(),
                })
            );
            setFavorites(next_state);
        });
        return unsubscribe;
    }, [getUser.checked, getUser.user, getUser.user.uid]);

    const itemIsFavorite = (itemId) => {
        return (
            favorites.findIndex((favorite) => favorite.favorite.id === itemId) >= 0
        );
    };

    const addFavorite = async (favoriteItem) => {
        try {
            if (!getUser.checked || !getUser.user) {
                throw new Error(
                    "Can't add favourite without an authenticated user"
                );
            }
			
			toast.success("Favorite added successfully!");
			
            //Build meetup doc reference
            const fav_doc = doc(db, "meetups", favoriteItem);

            // Create favorite document
            const user_id = getUser.user.uid;
            console.log({
                user_id: user_id,
                favorite: fav_doc,
            });
            await addDoc(collection(db, "user-favorites"), {
                user_id: user_id,
                favorite: fav_doc,
            });
        } catch (error) {
            console.log(error);
        }
    };

    const removeFavorite = async (itemId) => {
        try {
            if (!getUser.user || !getUser.checked) {
                throw new Error(
                    "Can't add favourite without an authenticated user"
                );
            }

			toast.success("Favorite removed successfully!");
            // Retrieve correct favorite from itemId
            const favorite_index = favorites.findIndex(
                (favorite) => favorite.favorite.id === itemId
            );
            if (favorite_index < 0) {
                throw new Error("No favorite matches that id");
            }
            const favorite = favorites[favorite_index];
            const favorite_doc = doc(db, "user-favorites", favorite.id);
            await deleteDoc(favorite_doc);
        } catch (error) {
            console.log(error);
        }
    };

    const context = {
        favorites,
        itemIsFavorite,
        removeFavorite,
        addFavorite,
        totalFavorites: favorites.length,
    };

    return (
        <FavoritesContext.Provider value={context}>
            {props.children}
        </FavoritesContext.Provider>
    );
};

export default FavoritesContext;
